import styled from "styled-components";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";

const ProfilePictureImageDefaultBox = styled.img`
    display: block;
    width: 9.1rem;
    height: 9.1rem;
`;

const ProfilePictureImageMrGreenBox = styled(ProfilePictureImageDefaultBox)`
    width: 9rem;
    height: 9rem;
`;

export const ProfilePictureImgBox = styledByTheme(ProfilePictureImageDefaultBox).forMrGreen(ProfilePictureImageMrGreenBox).apply();